var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92871 4.53369H4.80371V9.78369H3.92871V4.53369ZM6.55371 4.53369H7.42871V9.78369H6.55371V4.53369Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.428711 1.90869V2.78369H1.30371V11.5337C1.30371 11.7658 1.3959 11.9883 1.55999 12.1524C1.72409 12.3165 1.94665 12.4087 2.17871 12.4087H9.17871C9.41078 12.4087 9.63334 12.3165 9.79743 12.1524C9.96152 11.9883 10.0537 11.7658 10.0537 11.5337V2.78369H10.9287V1.90869H0.428711ZM2.17871 11.5337V2.78369H9.17871V11.5337H2.17871ZM3.92871 0.158691H7.42871V1.03369H3.92871V0.158691Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.36df99604437465189707d50047ab1cf.svg";
export { ForwardRef as ReactComponent };